import React, { useState } from 'react'
import Modal from '../../components/atoms/UI/Modal/Modal'


type PropsType = {
    children: any
    colorful?: boolean
    mode?: string | undefined
    unclosed?: boolean
}

export const useModal = () => {
    const [isVisible, setIsVisible] = useState(false)

    const show = () => {
        setIsVisible(true);
        document.body.style.overflow = 'hidden';
    }
    const hide = () => {
        setIsVisible(false);
        document.body.style.overflow = 'auto';
    }

    const RenderModal: React.FC<PropsType> = (props) => (
        <>
            {isVisible &&
                <Modal mode={props.mode}
                       closeModal={hide}
                       colorful={props.colorful}
                       unclosed={props.unclosed}>
                    {props.children}
                </Modal>}
        </>
    )

    return {
        show,
        hide,
        RenderModal,
    }
}